import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Loby from '../views/loby/index.vue'
import SelectServiceLine from '@/views/SelectServiceLine.vue'

export const enum ROUTES {
    LOBY = 'LOBY',
    GAME = 'GAME',
    SERVER_SELECTION = 'SERVER_SELECTION',
    LOGIN = 'LOGIN',
    MULTI_TABLE = 'MULTI_TABLE'
}

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: ROUTES.LOBY,
        component: Loby
    },
    {
        path: '/select-server-line',
        name: ROUTES.SERVER_SELECTION,
        component: SelectServiceLine
    },
    {
        path: '/login',
        name: ROUTES.LOGIN,
        component: () => import('@/views/login/index.vue')
    },
    {
        path: '/game',
        name: ROUTES.GAME,
        component: () => import('@/views/desk/index.vue')
    },
    {
        path: '/multi-betting',
        name: ROUTES.MULTI_TABLE,
        component: () => import('@/views/multi-view/index.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
